import React from 'react'
import { Navigate } from 'react-router-dom'

export const RedirectRoute = ({ to, replace = false }) => {
    return (
        <Navigate to={to} replace={replace} />
    )
}
